import React, { useEffect, useState, useCallback } from 'react';
import Loader from './components/AgendaContent/Loader';

import { today, dbDateToTimestamp, dbDateToExactTimestamp } from './utils/helpers';
import Filter from './Filter';

const App = ({ config, rootElement }) => {

	//state reflecting data and filtered data
	const [eventFeed, setEventFeed] = useState(null); //source data
	const [fetching, setFetching] = useState(true);

	//params available in dropdown for filter
	const [availableTypes, setAvailableTypes] = useState([]);
	const [availableCountries, setAvailableCountries] = useState([]);

	/**
	 * @description	Fetching feed
	 */
	async function fetchData() {
		const feedUrl = '/event_feed_json';
		const response = await fetch(feedUrl);
		if (!response.ok) {
			const message = `An error has occured: ${response.status}`;
    		throw new Error(message);
		}
		const data = await response.json();
		return data;
	};

  	/**
	 * @description	Retrieves available parameters for filtering from the feed + sets the state
	 */
	const parseEventData = useCallback((data) => {
		const allTypes = [];
		const allCountries = [];
		Object.values(data).forEach((event) => {
			if (event?.type) {
				!allTypes.some(type => Object.keys(type)[0] === Object.keys(event.type)[0]) && allTypes.push(event.type);
			}

			if (event?.country) {
				!allCountries.some(country => Object.keys(country)[0] === Object.keys(event.country)[0]) && allCountries.push(event.country);
			}
		});
		setAvailableTypes(allTypes);
		setAvailableCountries(allCountries);
	}, [config]);

	useEffect(() => {
		fetchData().then((data) => {
			data && parseEventData(data.events);
			data && setEventFeed(Object.values(data.events));
			setFetching(false);
		});
	}, []);

  	if (fetching) return (
		<div className="loader__container--agenda">
			<Loader />
		</div>
	);

	return (
		<Filter
			config={config}
			eventFeed={eventFeed}
			availableTypes={availableTypes}
			availableCountries={availableCountries}
			rootElement={rootElement}
		/>
	);
};

export default App;
